export default "__VITE_ASSET__Ri2BXxcw__"